import { useTranslation } from 'react-i18next'

import Button from '../../../../../Button'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../../Icon'
import Text from '../../../../../Text'
import { QA_NAME_LISTING_PROFILE_READINESS_FIX_BTN } from '../RentalPortalListingProfileWidgetPublishing.constants'

import * as styles from './ListingProfileWidgetPublishingCheck.module.css'

import CheckmarkIcon from '../../../../../../icons/checkmark.svg'

function ListingProfileWidgetPublishingCheck({
  hintKey,
  isDone,
  isFixable,
  isLast,
  isLineDone,
  labelKey,
  onClickFix,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.ListingProfileWidgetPublishingCheck}>
      <div className={styles.timeline}>
        <div className={isDone ? styles.circleDone : styles.circle}>
          {isDone ? (
            <IconNG
              Icon={CheckmarkIcon}
              color={ICON_COLOR.CurrentColor}
              size={ICON_HEIGHT_16}
            />
          ) : null}
        </div>
        {isLast ? null : (
          <div className={isLineDone ? styles.lineDone : styles.line} />
        )}
      </div>

      <div className={isLast ? styles.contentLast : styles.content}>
        {isFixable ? (
          <Button.Text
            isGrey
            className={styles.fixButton}
            qaName={QA_NAME_LISTING_PROFILE_READINESS_FIX_BTN}
            text={t(labelKey)}
            textClassName={styles.label}
            onClick={onClickFix}
          />
        ) : (
          <Text className={styles.label}>{t(labelKey)}</Text>
        )}

        {hintKey ? (
          <Text isSecondary className={styles.hint}>
            {t(hintKey)}
          </Text>
        ) : null}
      </div>
    </div>
  )
}

export default ListingProfileWidgetPublishingCheck
